/**
 * @fileoverview Main application component.
 * @package PlayItNow
 * @module apps/front/App
 * @author Pierre-Yves Léglise <contact@axialdata.net>
 * @license EULA
 */
import { Suspense } from 'react'
import { BrowserRouter } from 'react-router-dom'
import { I18nProvider } from './contexts/I18nContext'
import { CookieBanner } from './components/CookieBanner'
import { ErrorBoundary } from './components/ErrorBoundary'
import { PageBackground } from './components/PageBackground'
import { SkipLink } from './components/SkipLink'
import { SpinnerBig } from './components/SpinnerBig'
import { AppRoutes } from './routes'

/**
 * @summary Loading fallback component.
 */
// const PageLoader = () => <SpinnerBig />

function App() {
  return (
    <I18nProvider>
      <BrowserRouter>
        <SkipLink />
        <PageBackground />
        <div className="relative z-10 min-h-screen">
          <ErrorBoundary>
            <Suspense fallback={<SpinnerBig />}>
              <AppRoutes />
            </Suspense>
          </ErrorBoundary>
        </div>
        <CookieBanner />
      </BrowserRouter>
    </I18nProvider>
  )
}

export { App }
